import { render, staticRenderFns } from "./inquiry-price.vue?vue&type=template&id=4b755344&scoped=true"
import script from "./inquiry-price.vue?vue&type=script&lang=js"
export * from "./inquiry-price.vue?vue&type=script&lang=js"
import style0 from "./inquiry-price.vue?vue&type=style&index=0&id=4b755344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b755344",
  null
  
)

export default component.exports